// extracted by mini-css-extract-plugin
export default {"statusGroup":"ApplicationsStatusGroup_statusGroup__v8bZu","active":"ApplicationsStatusGroup_active__1CNMQ"};